module.exports = __webpack_public_path__ + "img/mine_active.18bc7ae6.png";